import { render, staticRenderFns } from "./employee-reward.vue?vue&type=template&id=74c9c3ca"
import script from "./employee-reward.vue?vue&type=script&lang=js"
export * from "./employee-reward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports